import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
    tab: z
        .enum([
            'organizations',
            'feature-flags',
            'org-settings',
            'twilio-provisioning',
            'rules-migration',
        ])
        .default('organizations'),
    flagKey: z.string().optional(),
    migrationOwnerEmails: z.array(z.string()).optional(),
    stages: z
        .array(
            z.enum([
                'pre_onboarding',
                'provisioning',
                'proposal_sent',
                'implementing',
                'live',
                'paused',
                'churned',
                'internal',
            ]),
        )
        .optional(),
    // `organizationId` would switch the admin's org context app-wide.
    migrationOrganizationId: z.string().optional(),
    // Org settings view state lives in the URL so "Copy link" shares it.
    columns: z.array(z.string()).optional(),
    filters: z
        .array(
            z.object({
                dimension: z.string(),
                operator: z.enum(['is', 'is_all', 'is_not']).optional(),
                values: z.array(z.string()),
            }),
        )
        .optional(),
});

export const Route = createFileRoute('/_app/admin/organizations/')({
    head: () => ({
        meta: [
            {
                title: 'Organizations | Phoebe Admin',
            },
        ],
    }),
    validateSearch: searchSchema,
});
